import 'jquery';
import Turbolinks from 'turbolinks';

const onLoad = () => {
	const scope = $('#scope-portfolio-view').val();

	if (scope !== 'provider')
		return;
}

$(() => {
	onLoad();
	document.addEventListener('turbolinks:load', onLoad);
});